import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

// TODO: type

export const useCommercialOffer = create(
  persist(
    (set) => ({
      selectedOffer: null,
      isMembershipSelected: null,
      creditLine: null,
      setSelectedOffer: (commercialOffer) =>
        set(() => ({
          selectedOffer: commercialOffer
        })),
      setIsMembershipSelected: (isMembershipSelected) =>
        set(() => ({
          isMembershipSelected
        })),
      setCreditLine: (creditLine) =>
        set(() => ({
          creditLine
        })),
      updateToDefault: () =>
        set(() => ({
          selectedOffer: null,
          isMembershipSelected: null,
          creditLine: null
        }))
    }),
    {
      name: 'commercial-offer',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
)

export const useAdvanceSuccess = create((set) => ({
  amount: 0,
  hasSubscribed: false,
  advanceType: null,
  isDelayed: false,
  updateAdvanceData: (a, h, t) =>
    set(() => ({
      amount: a,
      hasSubscribed: h,
      advanceType: t
    })),
  updateIsDelayed: (isDelayed) => set(() => ({ isDelayed }))
}))
